import { type RouteObject } from 'react-router'

import {
  NEW_PASSWORD,
  REQUEST_ACCESS,
  RESET_PASSWORD,
  SETUP_PASSWORD,
  SIGN_IN,
  SIGN_IN_CALLBACK,
  TRIAL_SIGNUP,
  VERIFY_USER,
} from 'features/auth/paths'
import { lazyComponent, lazyDefault } from 'routes/lazy-route'

export const authRoutes: RouteObject[] = [
  {
    path: SIGN_IN,
    lazy: lazyComponent(
      () => import('features/auth/forms/SigninForm'),
      'SignInForm',
    ),
  },
  {
    path: TRIAL_SIGNUP,
    lazy: lazyComponent(
      () => import('features/auth/forms/SignupTrialForm'),
      'SignUpTrialForm',
    ),
  },
  {
    path: SIGN_IN_CALLBACK,
    lazy: lazyComponent(
      () => import('features/auth/components/SigninCallback'),
      'SignInCallback',
    ),
  },
  {
    path: VERIFY_USER,
    lazy: lazyComponent(
      () => import('features/auth/forms/VerifyForm'),
      'VerifyForm',
    ),
  },
  {
    path: RESET_PASSWORD,
    lazy: lazyComponent(
      () => import('features/auth/forms/ResetPasswordForm'),
      'ResetPasswordForm',
    ),
  },
  {
    path: NEW_PASSWORD,
    lazy: lazyDefault(() => import('features/auth/forms/NewPasswordForm')),
  },
  {
    path: SETUP_PASSWORD,
    lazy: lazyComponent(
      () => import('features/auth/forms/SetupPasswordForm'),
      'SetupPasswordForm',
    ),
  },
]

export const requestAccessRoutes: RouteObject[] = [
  {
    path: REQUEST_ACCESS,
    lazy: lazyDefault(
      () => import('features/auth/components/RequestAccessPage'),
    ),
  },
]
